import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Carousel from "react-slick";
// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
import { API_BASE_URL } from "views/api"

const useStyles = makeStyles(styles);

export default function ProductSection(props) {
  const classes = useStyles();
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true
  };
  const link = `${API_BASE_URL}introduction/district-committee/`

  const [dcc_info_content, setDCCInfo] = React.useState(undefined);


  React.useEffect(() => {
    if (dcc_info_content === undefined) {
      fetch(link)
        .then(results => results.json())
        .then(data => {
          setDCCInfo(data.results[0]);
        });
    }
  });
  var HtmlToReactParser = require('html-to-react').Parser;
  var htmlToReactParser = new HtmlToReactParser();

  return (
    <div className={classes.section}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ color: "#134c7a", margin: 0}}>
            <small>परिचय</small>
            <span><h3 className={classes.title} style={{ marginTop: '0px', color: '#134c7a'}}>भक्तपुर जिल्ला समन्वय समिति</h3></span>
            <div style={{ width: '20px', borderBottom: "5px solid #134c7a", margin: 'auto' }}></div>
          </div>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Card carousel>
                <Carousel {...settings}>
                  {dcc_info_content && dcc_info_content.images && dcc_info_content.images.map((image)=>
                    <div>
                      <img src={image.image} alt="First slide" className="slick-image" />
                    </div>
                  )}
                </Carousel>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <div className={classes.description} style={{ height: '300px', padding: '10px', backgroundColor: '#eee',overflowY: 'auto',color: '#333', textAlign: 'left', marginTop: '40px' }}>
                {htmlToReactParser.parse((dcc_info_content && dcc_info_content.description)  || '<div class="lds-ellipsis extra-color-blue"><div></div><div></div><div></div><div></div></div>')}
              </div>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>
  );
}
